// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.select-location-item[data-v-ef28a10e] {\n  text-transform: uppercase;\n  font-size: 12px;\n}\n.batch-dialog-meta[data-v-ef28a10e] {\n  font-size: 12px;\n  margin-bottom: 10px;\n}\n.batch-dialog-error[data-v-ef28a10e] {\n  color: #d9534f;\n  font-size: 12px;\n}\n.batch-empty[data-v-ef28a10e] {\n  font-size: 12px;\n  padding: 10px;\n  background: #fafafa;\n  border: 1px solid #eee;\n  border-radius: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
